import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Battery } from '@/ui/icons/battery';
import { NoSmoking } from '@/ui/icons/no-smoking';
import { PersonSlash } from '@/ui/icons/person-slash';
import { ListItem } from '@/ui/list-item';

export default function DepositPolicy() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">Deposit Policy</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          Violating any of the following policies will result in your deposit
          being withheld.
        </Text>
      </View>

      <View style={{ gap: 16 }}>
        <ListItem
          text="No Running the Battery to 0%"
          caption="Avoid draining the battery completely to prevent damage and being stranded."
          icon={
            <Icon
              type="dressed"
              icon={<Battery />}
              fillColor={theme.colors.icon.color}
              width={25}
              height={25}
            />
          }
          onPress={() => {}}
          withBorder={false}
        />

        <ListItem
          text="No Smoking"
          caption="This includes cigarettes, marijuana, vapes, and any other substances."
          icon={
            <Icon type="dressed" icon={<NoSmoking />} width={25} height={25} />
          }
          onPress={() => {}}
          withBorder={false}
        />

        <ListItem
          text="No Unauthorized Drivers"
          caption="Only drivers listed in the rental agreement are allowed to operate the vehicle."
          icon={
            <Icon
              type="dressed"
              icon={<PersonSlash />}
              width={25}
              height={25}
              fillColor={theme.colors.icon.color}
            />
          }
          onPress={() => {}}
          withBorder={false}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
